'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.planUpgradeWidget = function (subscriptionPlanModel, subscriptionModel, taskBuilder /*pendingInvoicePoller*/) {
	return mmWidgets.each(this, function () {
		let currentPlan, currentTask;
		const widget = mmWidgets(this).sectionHandlerWidget(),
			planType = widget.attr('data-mm-plan-type'),
			invoiceTable = widget.find('[data-mm-role~="invoice"]'),
			planPrice = widget.find('[data-mm-role~="plan-price"]'),
			planDescription = widget.find('[data-mm-role~="plan-description"]'),
			invoiceItemTemplate = invoiceTable.find('[data-mm-role~="invoice-template-line"]').detach(),
			confirmButton = widget.find('[data-mm-role~="confirm-change-to-yearly"]'),
			predictedExpiryDate = widget.find('[data-mm-role~="predicted-expiry-date"]'),
			authoriseButton = widget.find('[data-mm-role~="authorise-payment"]'),
			cancelButton = widget.find('[data-mm-role~="cancel-task"]'),
			showPreview = (taskMetadata) => {
				const preview = taskMetadata.preview,
					previewItems = (preview && preview.lines) || [],
					currency = preview.currency || (previewItems && previewItems.length && previewItems[0].currency) || currentPlan.CCY,
					total = preview.total || previewItems.reduce((currentValue, item) => currentValue + item.amount, 0),
					totalItem = {description: 'Total to pay now', amount: total, currency: currency};
				if (total <= 0) {
					widget.showError('stripe-subscription-not-upgradable');
					widget.trigger('showPreviewComplete');
					return;
				}
				previewItems.push(totalItem);
				previewItems.forEach((item) => {
					const line = invoiceItemTemplate.clone(),
						amount = new Number(item.amount).toFixed(2);
					line.find('[data-mm-role~="invoice-description"]').text(item.description);
					line.find('[data-mm-role~="invoice-amount"]').text(`${amount} ${item.currency}`);
					invoiceTable.append(line);
				});
				predictedExpiryDate.text(new Date(preview.newExpiry * 1000).toDateString());
				
				trackEvent({
					action: 'popup_opened',
					popup_type: 'upgrade_subscription',
					upgrade_type: planDescription.first().text(),
					value: total
				});
				widget.showSection('preview');
				widget.trigger('showPreviewComplete');
			},
			requestPreview = async (plan) => {
				currentTask =  await taskBuilder.build(taskBuilder.newTaskId());
				await currentTask.exec('stripe/request_upgrade_preview', {newPlanId: plan.id});
				return currentTask.waitFor(task => task && (task.preview || task.error));
			},
			loadPreview = () => {
				widget.showProgressMessage('Checking your subscription, please wait...');
				return subscriptionModel.getSubscription()
				.then(subscription => subscriptionPlanModel.getUpgradePlan(subscription.actions, planType))
				.then(async plan => {
					if (!plan) {
						throw 'no-upgrade-plan';
					}
					const planDescriptionText =  plan.typeLabel || `${plan.period} ${plan.type}`;
					currentPlan = plan;
					invoiceTable.empty();
					planPrice.text(`${plan.prefix}${plan.price}${plan.postfix} ${plan.period}`);
					planDescription.text(planDescriptionText);
					return requestPreview(plan);
				})
				.then(showPreview)
				.catch(reason => {
					widget.showError(reason);
					widget.trigger('showPreviewError');
				});

			};
		widget.on('show', () => {
			loadPreview();
		});
		widget.on('hide', () => {
			if (currentTask) {
				currentTask.cancelIfWaiting();
			}
		});
		authoriseButton.click(() => {
			widget.showSection('payment-authorisation-progress');
		});
		cancelButton.click(async () => {
			if (currentTask) {
				await subscriptionModel.getGoldAccountDetails(true);
				return currentTask.cancel();
			}
		});
		confirmButton.click(() => {
			if (!currentTask || !currentPlan) {
				throw new Error('invalid-state');
			}
			widget.showProgressMessage('Preparing, please wait...');
			return currentTask.exec('stripe/request_upgrade', {newPlanId: currentPlan.id})
			.then(() => {
				widget.showProgressMessage('Contacting your payment provider...');
				return currentTask.waitFor(taskMetadata => ['cancelled', 'chargeSucceeded', 'chargeFailed', 'actionRequired'].includes(taskMetadata.status));
			})
			.then(async taskMetadata => {
				widget.showSection(taskMetadata.status);
				if (taskMetadata.status === 'actionRequired') {
					authoriseButton.attr('href', taskMetadata.actionUrl);
					taskMetadata = await currentTask.waitFor(metadata => ['cancelled', 'chargeSucceeded', 'chargeFailed'].includes(metadata.status));
					widget.trigger('action-required');
					return taskMetadata;
				}
				return taskMetadata;
			})
			.then(async taskMetadata => {
				await subscriptionModel.getGoldAccountDetails(true);
				widget.showSection(taskMetadata.status);
				widget.trigger('confirm-button-click-complete');
				
				trackEvent({
					action: 'upgrade_completed',
					upgrade_type: planDescription.first().text(),
					value: taskMetadata.preview?.total,
					currency: taskMetadata.preview?.currency
				});
			});
		});

	});
};

